import { ConnectionError, ServiceUnavailableError } from '../app/errors';

const constructCashInPricesUrl = (betIds) => (
  `${api_config.bet_tracker_api}/bet/${betIds.join(',')}/cashInPrice`
);

export default (betIds) => (
  fetch(constructCashInPricesUrl(betIds), {
    method: 'GET',
    cache: 'no-cache'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 200: {
          return response;
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => response.json())
    .then(results => results.bets)
);
